import React, { createContext, useReducer, useState, useEffect } from 'react';
import axios from 'axios';

import { apiRoute } from '../App.js';

const PaymentPlanContext = createContext({
    paymentPlanFrequencyList: Array,
    setPaymentPlanFrequencyList: () => { },
    paymentPlanTypes: Array,
    setPaymentPlanTypes: () => { },
    paymentPlanPeriodicityList: Array,
    setPaymentPlanPeriodicityList: () => { },
    retrievePaymentPlanFrequencyList: async () => { },
    retrievePaymentPlanTypesList: async () => { },
    retrievePaymentPlanPeriodicityList: async () => { },
    retrievePaymentPlanSetupData: async () => { },
    handleResetPaymentPlanState: () => { },
    handlePaymentPlanFieldChange: () => { },
    paymentPlanState: Object,
    createPaymentPlan: async () => { },
    retrievePaymentPlanByCaseId: async () => { },
    retrievePaymentPlanByViolationId: async () => { },
    paymentPlans: Array,
    setPaymentPlans: () => { },
    retrievePaymentPlanInstallmentTbl: async () => { },
    installments: Array,
    setInstallmemt: () => { },
    installmentDetailsReceived: Boolean,
    setDetailsReceived: () => { },
    deletePaymentPlan: async () => { },
    paymentPlanTemplates: Object,
    setPaymentPlanTemplates: () => { },
    frequencyDetails: Boolean,
    setFrequencyDetails: () => { },
    updatePaymentPlan: async () => { },
    updatePlanModal: Boolean,
    setUpdatePlanModal: () => { },
    restorePaymentPlan: async () => { }
})

const PaymentPlanProvider = ({ children }) => {
    const [paymentPlanFrequencyList, setPaymentPlanFrequencyList] = useState([]);
    const [paymentPlanTypes, setPaymentPlanTypes] = useState([]);
    const [paymentPlanPeriodicityList, setPaymentPlanPeriodicityList] = useState([]);
    const [paymentPlans, setPaymentPlans] = useState([]);
    const [installments, setInstallmemts] = useState([]);
    const [installmentDetailsReceived, setDetailsReceived] = useState(false);
    const [frequencyDetails, setFrequencyDetails] = useState(false);
    const [planType,] = useState('planType');
    const [customPlan,] = useState('CUSTOM');
    const [customPlanId, setCustomPlanId] = useState();
    const [updatePlanModal, setUpdatePlanModal] = useState(false);

    //TODO setup monthly, weekly, and annual templates

    async function retrievePaymentPlanFrequencyList() {
        try {
            const { data } = await axios.get(`${apiRoute}/api/paymentPlanFrequency`);
            setPaymentPlanFrequencyList(data);
        } catch (err) {
            console.log('err', err);
        }
    }
    async function retrievePaymentPlanTypesList() {
        try {
            const { data } = await axios.get(`${apiRoute}/api/paymentPlanType`);
            setPaymentPlanTypes(data);
            const customPlanId = data?.filter(d => d?.description?.includes(customPlan))[0]?.id;
            if (customPlanId != null || customPlanId !== undefined) {
                setCustomPaymentPlanState((prev) => {
                    const plan = prev;
                    plan.planType = customPlanId;
                    return plan;
                });
                setCustomPlanId(customPlanId);
            }
        } catch (err) {
            console.log('err', err);
        }
    }
    async function retrievePaymentPlanPeriodicityList() {
        try {
            const { data } = await axios.get(`${apiRoute}/api/paymentPlanPeriodicity`);
            setPaymentPlanPeriodicityList(data);

        } catch (err) {
            console.log('err', err);
        }
    }

    const initialPaymentPlanState = {
        planType: '',
        frequencyId: '',
        periodicityId: '',
        installmentAmount: '$0.00',
        planDuration: '0',
        planStartDate: null,
        planEndDate: null,
        disabled: true,
        planAmount: '$0.00',
    };

    const [resetPaymentPlanState,] = useState({
        planType: '',
        frequencyId: '',
        periodicityId: '',
        installmentAmount: '$0.00',
        planDuration: '0',
        planStartDate: null,
        planEndDate: null,
        disabled: true,
        planAmount: '$0.00',
    });

    const [customPaymentPlanState, setCustomPaymentPlanState] = useState({
        planType: '',
        frequencyId: '',
        periodicityId: '',
        installmentAmount: '$0.00',
        planDuration: '0',
        planStartDate: null,
        planEndDate: null,
        disabled: true,
        planAmount: '$0.00',
    });


    const [paymentPlanTemplates, setPaymentPlanTemplates] = useState({
        '': resetPaymentPlanState,
        custom: customPaymentPlanState,
    });

    const handleResetPaymentPlanState = () => {
        paymentPlanDispatch({ type: 'RESET_PAYMENT_PLAN_STATE', resetPaymentPlanState });
    };

    const handlePaymentPlanFieldChange = (field, value) => {
        const arr = [];
        if (field === planType) {
            paymentPlanDispatch({ type: 'UPDATE_PLAN_TYPE', field, value });
            if (value === customPlanId) {
                setFrequencyDetails(true);
            } else {
                setFrequencyDetails(false);
            }
        }
        paymentPlanDispatch({ type: 'UPDATE_FIELD', field, value });
    };

    const paymentPlanReducer = (state, action) => {
        switch (action.type) {
            case 'UPDATE_FIELD':
                state[action.field] = action.value;
                for (const obj in state) {
                    if (action.value == null || action.value === undefined || action.value === "") {
                        state.disabled = true;
                        break;
                    }
                    else if (state[obj] == null || state[obj] === undefined || state[obj] === "") {
                        state.disabled = true;
                        break;
                    }
                    else {
                        state.disabled = false;
                    }
                };
                return {
                    ...state,
                    [action.field]: action.value,
                };
            case 'UPDATE_FIELD_ERROR':
                return {
                    ...state,
                    errors: {
                        ...state.errors,
                        [action.field]: action.error,
                    }
                };
            case 'CLEAR_FIELD_ERROR':
                const updatedErrors = { ...state.errors };
                delete updatedErrors[action.field];
                return {
                    ...state,
                    errors: updatedErrors,
                };
            case 'RESET_PAYMENT_PLAN_STATE':
                return resetPaymentPlanState;
            case 'UPDATE_PLAN_TYPE':
                paymentPlanTemplates[action.value].planAmount = state.planAmount;
                paymentPlanTemplates[action.value].planStartDate = state.planStartDate;
                paymentPlanTemplates[action.value].planEndDate = state.planEndDate;
                return paymentPlanTemplates[action.value]
            default:
                return state;
        }
    };

    const [paymentPlanState, paymentPlanDispatch] = useReducer(paymentPlanReducer, initialPaymentPlanState);

    async function createPaymentPlan(state, caseNumber, fkViolationId) {
        try {
            const planAmount = state.planAmount.slice(1,);
            const paymentPlanDto = {
                CaseId: caseNumber,
                ViolationId: fkViolationId,
                PaymentPlanAmount: parseFloat(planAmount.replace(/[^0-9.]/g, '')),
                PaymentPlanType: state.planTypeId,
                PaymentPlanFrequency: parseFloat(state.frequencyId),
                PaymentPlanPeriodicity: parseFloat(state.periodicityId),
                PaymentPlanDuration: state.planDuration,
                PaymentPlanStartDate: new Date(state.planStartDate).toUTCString(),
                PaymentPlanEndDate: new Date(state.planEndDate).toUTCString(),
            };

            const { data } = await axios.post(`${apiRoute}/api/paymentPlan`, paymentPlanDto);
            return data;
        }
        catch (err) {
            console.log('err create payment plan: ', err);
        }
    }

    async function deletePaymentPlan(id) {
        try {
            const { data } = await axios.delete(`${apiRoute}/api/paymentPlan/${id}`);
        }
        catch (err) {
            console.log('err retoring payment plan')
        }
    }

    async function restorePaymentPlan(id) {
        try {
            const { data } = await axios.put(`${apiRoute}/api/paymentPlan/restore/${id}`);
            console.log('data: ', data);
        }
        catch (err) {
            console.log('err restoring payment plan', err);
        }
    }

    async function updatePaymentPlan(id, state, caseNumber, fkViolationId) {

        try {
            const planAmount = state.planAmount.slice(1,)
            const paymentPlanDto = {
                CaseId: caseNumber,
                ViolationId: fkViolationId,
                InstallmentAmount: '0.00',
                PaymentPlanType: state.planTypeId,
                PaymentPlanAmount: parseFloat(planAmount.replace(/[^0-9.]/g, '')),
                PaymentPlanFrequency: parseFloat(state.frequencyId),
                PaymentPlanPeriodicity: parseFloat(state.periodicityId),
                PaymentPlanDuration: state.planDuration,
                PaymentPlanStartDate: new Date(state.planStartDate).toUTCString(),
                PaymentPlanEndDate: new Date(state.planEndDate).toUTCString(),
            };
            const { data } = await axios.put(`${apiRoute}/api/paymentPlan/${id}`, paymentPlanDto);
            await retrievePaymentPlanByCaseId(caseNumber);
        }
        catch (err) {
            console.log('err deleting payment plan', err);
        }
    }


    async function retrievePaymentPlanByCaseId(caseId) {
        try {
            // 1:1 violation to payment plan
            const { data } = await axios.get(`${apiRoute}/api/paymentPlan/caseId/${caseId}`);
            data.paymentPlans.forEach(pp => pp.schedule.planAmount = pp.totalInstallmentAmount);
            setPaymentPlans(data);
        }
        catch (err) {
            console.log('err retrieving payment plan: ', err);
        }
    }

    async function retrievePaymentPlanByViolationId(violationId) {
        try {
            //can return a list of payment plans with 1:many relationship for case to violations
            const { data } = await axios.get(`${apiRoute}/api/paymentPlan/caseId/${violationId}`);
            console.log('data: ', data);
        }
        catch (err) {
            console.log('err create payment plan: ', err);
        }
    }

    async function retrievePaymentPlanInstallmentTbl(scheduleId) {
        try {
            const { data } = await axios.get(`${apiRoute}/api/paymentPlanInstallment/schedule/${scheduleId}`);
            setInstallmemts(data);
            return data;
        }
        catch (err) {
            console.log('err retrieve payment plan installment tbl', err);
        }
    }

    async function retrievePaymentPlanTemplates() {
        try {
            const { data } = await axios.get(`${apiRoute}/api/PaymentPlanTemplate/GetPaymentPlanTemplatesByTenantId`);
            data.templates.forEach((d, i) => {
                d.frequencyId = d.frequencyId.toString();
                d.periodicityId = d.periodicityId.toString();
                d.planType = d.planTypeId.toString();
                d.planEndDate = null;
                d.planStartDate = null;
                d.disabled = true;
                delete d.updatedAt;
                delete d.updatedBy;
                d.installmentAmount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(d.installmentAmount);
                setPaymentPlanTemplates((prev) => {
                    const plan = prev;
                    plan[d.planTypeId] = d;
                    return plan;
                })
            })
        }
        catch (err) {
            console.log('err retrieving payment plan templates', err);
        }
    };

    async function retrievePaymentPlanSetupData() {
        try {
            await retrievePaymentPlanFrequencyList();
            await retrievePaymentPlanTypesList();
            await retrievePaymentPlanPeriodicityList();
            await retrievePaymentPlanTemplates();
        } catch (err) {
            console.log('err', err);
        }
    }

    const contextValue = {
        paymentPlanFrequencyList: paymentPlanFrequencyList,
        setPaymentPlanFrequencyList,
        paymentPlanTypes: paymentPlanTypes,
        setPaymentPlanTypes,
        paymentPlanPeriodicityList: paymentPlanPeriodicityList,
        setPaymentPlanPeriodicityList,
        retrievePaymentPlanFrequencyList,
        retrievePaymentPlanTypesList,
        retrievePaymentPlanPeriodicityList,
        retrievePaymentPlanSetupData,
        handleResetPaymentPlanState,
        handlePaymentPlanFieldChange,
        paymentPlanState,
        createPaymentPlan,
        retrievePaymentPlanByCaseId,
        retrievePaymentPlanByViolationId,
        paymentPlans: paymentPlans,
        setPaymentPlans,
        retrievePaymentPlanInstallmentTbl,
        installments: installments,
        setInstallmemts,
        installmentDetailsReceived: installmentDetailsReceived,
        setDetailsReceived,
        deletePaymentPlan,
        paymentPlanTemplates: paymentPlanTemplates,
        setPaymentPlanTemplates,
        frequencyDetails: frequencyDetails,
        setFrequencyDetails,
        updatePaymentPlan,
        updatePlanModal: updatePlanModal,
        setUpdatePlanModal,
        restorePaymentPlan
    };

    return (
        <PaymentPlanContext.Provider value={contextValue}>{children}</PaymentPlanContext.Provider>
    )
}

export default PaymentPlanProvider;
export { PaymentPlanContext }